export default __webpack_public_path__ + "static/media/coins.5bf6fd83.png";